module.exports = __webpack_public_path__ + "static/bismillah-a3eb47c707c325f064a5a7b33a976af0.svg";